// extracted by mini-css-extract-plugin
export var container = "_ic-1";
export var cornerButtonContainer = "_ic-6";
export var disabled = "_ic-2";
export var dragActive = "_ic-3";
export var fileContainer = "_ic-5";
export var hiddenInput = "_ic-4";
export var widthContainer = "_ic-0";